<div
  class="container d-flex justify-content-center align-items-center flex-column"
  style="
    min-height: 100vh;
    text-align: center;
    padding: 0 16px;
    background-color: #f8f9fa;
  "
>
  <h1
    style="
      font-size: 6rem;
      font-weight: 700;
      color: #d32f2f;
      margin-bottom: 16px;
    "
  >
    404
  </h1>

  <p style="font-size: 1.25rem; color: #555; margin-bottom: 24px">
    Oops! The page you’re looking for doesn’t exist or has been moved.
  </p>

  <button
    mat-flat-button
    color="primary"
    [routerLink]="['/plan']"
    style="padding: 12px 24px; font-size: 1rem; font-weight: 500"
  >
    <mat-icon style="vertical-align: middle">arrow_back</mat-icon>
    &nbsp; Back to Plans
  </button>
</div>
